import React from 'react';
import { Collapse, Form, Input, message, Select, Button } from 'antd';
import { AiOutlinePaperClip } from 'react-icons/ai';
import CampQuickViewComponent from './CampQuickViewComponent';
import { dispatch, useGlobalState } from '../../../../store/state';
// import { UpdateCampLiveData } from '../../../../utils/UpdateCampLiveData';
import { checkObjectKeyValues, convertArraytoCSV, replaceSpaceWithComma, URLValidator } from '../../../../utils';
import { CampaignDraft } from '../../../../apis/Brand/Campaigns/CampaignDraft';
import { SyncCampiagnData } from '../../../../utils/SyncCampiagnData';

const CampStep2Component = ({ className }) => {
  const [user] = useGlobalState('user');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  const [create_camp_general] = useGlobalState('create_camp_general');
  const [company] = useGlobalState('company');
  const [campDefSet] = useGlobalState('campDefSet');
  const { Item } = Form;
  const { Panel } = Collapse;
  const { TextArea } = Input;
  const { Option } = Select;
  const [formSet2] = Form.useForm();
  const saveSet2Draft = (btnType)=>{
    const _set2PrepData = formSet2.getFieldsValue();
    console.log('set2 prop data ==>', _set2PrepData);
    _set2PrepData.hashtags = _set2PrepData.hashtags ? _set2PrepData.hashtags : undefined;
    _set2PrepData.keywords = _set2PrepData.keywords ? _set2PrepData.keywords : undefined;
    _set2PrepData.mentions = _set2PrepData.mentions ? _set2PrepData.mentions : undefined;

    // note: only accept correct refernce added remove wrong
    if (_set2PrepData.referencelink.length) {
      const _correctLinks = [];
      _set2PrepData.referencelink.map((link)=>{
        if (URLValidator(link)) {
          return _correctLinks.push(link);
        }
      });
      // console.log("good links",_correctLinks)
      _set2PrepData.referencelink = _correctLinks || [];
    }

    // note: here base data will be saved if campaign not created will create it first
    if (_set2PrepData) {
      SyncCampiagnData(
        create_camp_draft, // store sync object
        company.selected.id, // active company id
        campDefSet, // default field set for pre filter
        {
          campaignid: create_camp_draft.campaignid,
          data: checkObjectKeyValues(_set2PrepData),
        }, // updated set of data to process
      ).then((data)=>{
        CampaignDraft(user.accessToken, checkObjectKeyValues(data, true)).then(({ response, status })=>{
          // console.log("response update",response)
          if (status === 200) {
            SyncCampiagnData(
              create_camp_draft,
              company.selected.id,
              campDefSet,
              {
                campaignid: response.id,
                data: response.object,
              },
            );
            message.success(response.msg); // success msg to UI
            // note: if user clicked on save and proceed
            if (btnType === 'proceed') {
              dispatch({
                type: 'SET_CAMP_GENERAL',
                payload: {
                  ...create_camp_general,
                  currentPanel: 2,
                },
              });
            }
          } else {
            console.log('eer', response);
            message.error( // erro list print in UI
              <div className="m-0 list-group">
                <h6 className="pt-2">Following issues found</h6>
                {response.errors && response.errors.map((err, index) =>(
                  <div className="py-1"
                    key={index}>{err.msg._message}</div>
                ))}
              </div>,
            );
          }
        });
      });
    }
  };
  return (
    <div className={className}>
      <div className="d-flex py-3">
        <div className="col-md-8 pr-2">
          <Form
            form={formSet2}
            layout={'vertical'}
            requiredMark={false}
            name="campSet2Form"
          >
            <Collapse
              className="acc_campaign common_collapse"
              showArrow={false}
              defaultActiveKey={[1]}
            >
              <Panel showArrow={false}
                key="1"
                header={
                  <h3><AiOutlinePaperClip/> Brief</h3>
                }>
                <div className="acc_campaign_set">
                  <div className="row pt-2">
                    <div className="col-12">
                      <Item
                        initialValue={create_camp_draft.brief || ''}
                        label="Campaign Description (required)"
                        name="brief"
                      >
                        <TextArea rows={6}
                          className="common_input"
                          placeholder="Description"
                          size="large"/>
                      </Item>
                    </div>
                    <div className="col-md-6 pr-2">
                      <Item
                        initialValue={create_camp_draft.hashtags || undefined}
                        label="Hashtags"
                        name="hashtags"
                      >
                        <Select className="common_select"
                          mode="tags"
                          size="large"
                          placeholder="Search or Select">
                          <Option value="productlaunch">#productlaunch</Option>
                          <Option value="new">#new</Option>
                          <Option value="trending">#trending</Option>
                          <Option value="exclusive">#exclusive</Option>
                          <Option value="sale">#sale</Option>
                          <Option value="instock">#instock</Option>
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pl-2">
                      <Item
                        initialValue={create_camp_draft.keywords || undefined}
                        label="Keywords"
                        name="keywords"
                      >
                        <Select className="common_select"
                          size="large"
                          mode="tags"
                          placeholder="Search or Select">
                          <Option value="discount">discount</Option>
                          <Option value="nike">nike</Option>
                          <Option value="adidas">adidas</Option>
                          <Option value="puma">puma</Option>
                          <Option value="new">new</Option>
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pr-2">
                      <Item
                        initialValue={create_camp_draft.mentions || undefined}
                        label="Mentions"
                        name="mentions"
                      >
                        {/* <Mentions autoSize placeholder="search using @">
                                                    <Mentions.Option value="nike">nike</Mentions.Option>
                                                    <Mentions.Option value="adidas">adidas</Mentions.Option>
                                                    <Mentions.Option value="puma">puma</Mentions.Option>
                                                </Mentions> */}
                        <Select className="common_select"
                          size="large"
                          mode="tags"
                          placeholder="Search or Select">
                          <Option value="@nike">nike</Option>
                          <Option value="@adidas">adidas</Option>
                          <Option value="@puma">puma</Option>
                          <Option value="new">new</Option>
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pl-2">
                      <Item
                        initialValue={create_camp_draft.referencelink || [undefined]}
                        label="Reference Links"
                        name="referencelink"
                        rules={[
                          {
                            // validator: (_, value) =>
                            validator: (_, value) =>{
                              console.log('V', _);
                              // let _fval = getFieldValue('withdrawAmount');
                              if (value) {
                                const _er = value.some((item)=> {
                                  return !URLValidator(item);
                                });
                                return _er ? Promise.reject(new Error('There is some invalid URL\'s')) : Promise.resolve();
                              } else {
                                return Promise.resolve();
                              }
                            },
                          },
                        ]}
                      >
                        <Select size="large"
                          className="common_select"
                          mode="tags"
                          maxTagCount="responsive"
                          placeholder="Search or Select">
                          <Option value="https://google.com">google.com</Option>
                          <Option value="https://adidas.com">nike.com</Option>
                          <Option value="https://puma.com">puma.com</Option>
                        </Select>
                      </Item>
                    </div>
                    <div className="col-12">
                      <Item
                        initialValue={create_camp_draft.thingstoavoid || ''}
                        label="Campaign Guidelines"
                        name="thingstoavoid"
                      >
                        <TextArea className="common_input"
                          rows={6}
                          placeholder="Guidelines"
                          size="large"/>
                      </Item>
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </Form>
          {/* proceed button [start]*/}
          <Button className="mt-2 common_button w-100"
            onClick={() => saveSet2Draft('proceed')}>SAVE AND PROCEED</Button>
          {/* proceed button [end]*/}
        </div>
        <div className="col-md-4 pl-2">
          {create_camp_draft.campaignid ?<CampQuickViewComponent onSaveDraft={saveSet2Draft}/>: null}
        </div>
      </div>
    </div>
  );
};

export default CampStep2Component;
